import { Helpers } from '../../helpers';
import { IPhaseStepScheduleType } from '../../interfaces/iphase-step-schedule-type';
import { PhaseStepType } from '../phase-step-type';

export class PhaseStepScheduleTypeBase {
  PhaseStepScheduleTypeId: number;
  Name: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  PhaseStepTypes_PhaseStepScheduleType?: Array<PhaseStepType> | null;

  constructor(item?: IPhaseStepScheduleType) {
    if (item) {

      this.PhaseStepScheduleTypeId = item.PhaseStepScheduleTypeId;
      this.Name = item.Name;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.PhaseStepTypes_PhaseStepScheduleType = Helpers.createClassArray(PhaseStepType, item.PhaseStepTypes_PhaseStepScheduleType);
    }
  }
}